import React from "react";

export default function Header() {
  return (
    <>
      <div className="hero-area hero-bggg">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 offset-lg-2 text-center">
              <div className="hero-text">
                <div className="hero-text-tablecell">
                  <p className="subtitle">Satisfying Your Sweet tooth</p>
                  <h1> Sweet Slice</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
